// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ffed3cde","586":"fce6fac5"}[chunkId] + ".chunk.js";
};